<template>
    <div class="expand-check-list">
        <div
            v-for="(data, idx) in dataList"
            :key="`${idx}-data-list`"
            :id="`${idx}-data-list`"
            class="list-wrapper m-d-16"
        >
            <div class="d-grid-12 data-header">
                <div class="grid-cspan-2 j-self-center a-self-center" @click="toogleCheck(idx, data[childIndex])">
                    <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        v-if="isChecked(idx, data[childIndex]) === 'unCheck'"
                    >
                        <rect x="0.5" y="1" width="15" height="15" rx="2.5" fill="white" />
                        <rect x="0.5" y="1" width="15" height="15" rx="2.5" stroke="#C8D0DD" />
                    </svg>

                    <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        v-if="isChecked(idx, data[childIndex]) === 'checkAll'"
                    >
                        <rect y="0.5" width="16" height="16" rx="3" fill="#206CFF" />
                        <path
                            d="M6.46154 11.5686L5.90475 12.0711L6.46154 12.6881L7.01832 12.0711L6.46154 11.5686ZM3.44321 9.34356L5.90475 12.0711L7.01832 11.0661L4.55679 8.33859L3.44321 9.34356ZM7.01832 12.0711L12.5568 5.93412L11.4432 4.92916L5.90475 11.0661L7.01832 12.0711Z"
                            fill="white"
                        />
                    </svg>

                    <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        v-if="isChecked(idx, data[childIndex]) === 'notAll'"
                    >
                        <rect y="0.5" width="16" height="16" rx="3" fill="#206CFF" />
                        <path d="M4 9.25H12.0004V7.75H4V9.25Z" fill="white" />
                    </svg>
                </div>
                <div class="grid-cspan-8" @click="toogleExpand(idx, data)">
                    <p class="m-d-0">{{ data.tanggal_formated }}</p>
                    <p class="m-d-0">{{ data.jumlah_transaksi }} Transaksi • {{ data.total_transaksi | currency }}</p>
                </div>
                <div class="grid-cspan-2 j-self-center a-self-center" @click="toogleExpand(idx, data)">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        :class="{ rotate_icon_180: data.expand, rotate_icon_0: !data.expand }"
                    >
                        <path
                            d="M5 7.5L10 12.5L15 7.5"
                            stroke="#6F7287"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </div>
            <div class="body-wrapper" :id="`${idx}-body-content`">
                <div
                    class="d-grid-12 data-body"
                    v-for="(item, idy) in data[childIndex]"
                    :key="`${idy}-data-item`"
                    @click="toggleItem(idx, item)"
                >
                    <div class="grid-cspan-2 j-self-center a-self-center">
                        <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            v-if="!isSelected(idx, item.idbayar)"
                        >
                            <rect x="0.5" y="1" width="15" height="15" rx="2.5" fill="white" />
                            <rect x="0.5" y="1" width="15" height="15" rx="2.5" stroke="#C8D0DD" />
                        </svg>

                        <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            v-else
                        >
                            <rect y="0.5" width="16" height="16" rx="3" fill="#206CFF" />
                            <path
                                d="M6.46154 11.5686L5.90475 12.0711L6.46154 12.6881L7.01832 12.0711L6.46154 11.5686ZM3.44321 9.34356L5.90475 12.0711L7.01832 11.0661L4.55679 8.33859L3.44321 9.34356ZM7.01832 12.0711L12.5568 5.93412L11.4432 4.92916L5.90475 11.0661L7.01832 12.0711Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <div class="grid-cspan-10">
                        <p class="m-d-0">
                            {{ item.nominal | currency }} <span class="f-12 f-c-midgrey">{{ item.idbayar }}</span>
                        </p>
                        <p class="m-d-0 f-12 f-c-midgrey">
                            {{ item.waktu_transaksi_formated }} oleh {{ item.nama_karyawan }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ExpandCheckList",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
        childIndex: {
            type: String,
            required: true,
        },
        selected: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    mounted() {
        this.initToggleClass();
    },
    computed: {
        isSelected() {
            return function(idx, idbayar) {
                let data = this.selected.find((dt) => dt.dataIndex === idx);

                let itemIdx = data.items.findIndex((data) => data.idbayar === idbayar);

                return itemIdx === -1 ? false : true;
            };
        },
        isChecked() {
            return function(idx, data) {
                let items = data.length;
                let selectedItem = this.selected[idx].items.length;

                let isCheck = items === selectedItem ? "checkAll" : "notAll";
                if (selectedItem === 0) {
                    isCheck = "unCheck";
                }
                return isCheck;
            };
        },
    },
    methods: {
        async toogleExpand(idx, data) {
            if (data[this.childIndex].length > 0) {
                data.expand = data.expand ? false : true;
                await this.$forceUpdate();
                if (data.expand) {
                    await this.toogleShowClass(idx, data[this.childIndex].length, true);
                } else {
                    await this.toogleShowClass(idx, 0, false);
                }
            }
        },
        initToggleClass() {
            this.dataList.forEach((data, idx) => {
                if (data.expand) {
                    this.toogleShowClass(idx, data[this.childIndex].length, true);
                } else {
                    this.toogleShowClass(idx, 0, false);
                }
            });
        },
        toogleShowClass(idx, countItem, val) {
            let el = document.getElementById(`${idx}-body-content`);
            let body = document.getElementsByClassName("data-body");
            let elHeight = countItem * body[0].offsetHeight;

            if (val) {
                el.style.height = `${elHeight}px`;
                el.classList.add("show");
            } else {
                el.style.height = `0px`;
                el.classList.remove("show");
            }
        },
        toggleItem(idx, data) {
            this.$emit("toggleItemSelected", { idx, data });
        },
        toogleCheck(idx, data) {
            this.$emit("toogleCheckAll", { idx, data, status: this.isChecked(idx, data) });
        },
    },
};
</script>
<style scoped>
.expand-check-list .list-wrapper {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 4px;
}
.expand-check-list .data-header,
.expand-check-list .data-body {
    padding: 10px;
    padding-left: 0px;
    border-bottom: 1px solid #ededed;
}
.expand-check-list .data-header {
    background: #f6f6f6;
}

.expand-check-list .rotate_icon_180 {
    transform: rotate(180deg);
    transition-duration: 300ms;
}

.expand-check-list .rotate_icon_0 {
    transform: rotate(0deg);
    transition-duration: 300ms;
}

.expand-check-list .body-wrapper {
    height: 0px;
    transition: height 0.2s ease-out;
    overflow: hidden;
}
.expand-check-list .body-wrapper.show {
    transition: height 0.2s ease-in;
}
</style>
